import React from "react";
import { Content, ContentProps } from "@emisgroup/ui-dialog";

interface CustomContentProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type ContProps = ContentProps & CustomContentProps;

/**
 * Responsible for rendering the dialog content component
 * @returns dialog content element
 */
export const UIContent: React.FC<ContProps> = (props: ContProps) => {

  const { children, className } = props;

  return (
    <Content
      className={`${className} ui-dialog-content`}
      {...props}
    >
      {children}
    </Content>
  );
};
